import AppDispatcher from "../dispatcher/AppDispatcher"
import { EventEmitter } from "events"
import Constants from "../constants/Constants"
import assign from "object-assign"

import Faq from "../vo/Faq"


var CHANGE_EVENT = "change"

var _item = null
var _items = []


const setList = (items) => {
  _items = items.map( item => {
    return Faq(item)
  })
}

const update = (name,value) => {
  _item = _item.set(name, value)
}

const setItem = (item) => {
  _item = item
}


var FaqStore = assign({},EventEmitter.prototype,{

  getList(){
    return _items
  },

  getItem(){
    return _item
  },

  getDisplayOrderMax(){
    if(_items.length === 0) return 0
    else return _items.reduce((a,b)=>a.display_order>b.display_order?a.display_order:b.display_order).display_order
  },

  emitChange(str =  CHANGE_EVENT){ // 何かアクションがあったことを知らせる
    this.emit(str)
  },

  addChangeListener(callback,str =  CHANGE_EVENT){ // リスナーに追加
    this.on(str, callback)
  },

  removeChangeListener(callback,str =  CHANGE_EVENT){ // リスナーから削除
    this.removeListener(str, callback)
  },


})

AppDispatcher.register((action)=>{

  switch(action.actionType){ // actionTypeでswitchする
    case Constants.FAQ_LIST_LOADED:
      setList(action.list);
      FaqStore.emitChange()
    break;
    case Constants.FAQ_UPDATE:
      update(action.name,action.value);
      FaqStore.emitChange()
    break;
    case Constants.FAQ_SET_ITEM:
      setItem(action.item);
      FaqStore.emitChange()
    break;

    default:
  }


})
export default FaqStore
